// extracted by mini-css-extract-plugin
export var button = "_dn-7";
export var buttonRow = "_dn-6";
export var fadeIn = "_dn-1";
export var gradient = "_dn-0";
export var panel = "_dn-2";
export var panelIn = "_dn-3";
export var subtitle = "_dn-5";
export var title = "_dn-4";